import { Toaster, ToastReference } from '@economic/taco';
import { getAPIErrorValidation, getErrorMessage } from '../../../../../../utilities/parseAPIValidationErrors';

export function handleError(error, toast: Toaster<ToastReference>) {
    if (!error) {
        return;
    }

    error.validation = getAPIErrorValidation(error);
    const errorMessage = getErrorMessage(error, error.response?.data?.message);
    toast?.error(errorMessage);
}
